import { auth } from "@/services/firebase.provider";

class AuthService {
  authenticate({ email, password }) {
    return new Promise((resolve, reject) => {
      auth
        .signInWithEmailAndPassword(email, password)
        .then(user => resolve(this.mapFirebaseToCrushUser(user)))
        .catch(error => reject(this.mapError(error)));
    });
  }

  getCurrentUser() {
    return new Promise(resolve => {
      auth.onAuthStateChanged(currentUser =>
        resolve(this.mapFirebaseToCrushUser(currentUser))
      );
    });
  }

  mapFirebaseToCrushUser(firebaseUser) {
    return firebaseUser ? { email: firebaseUser.email } : null;
  }

  mapError(error) {
    return { code: error.code };
  }

  logout() {
    return auth.signOut();
  }
}

export default new AuthService();
